module.exports = __webpack_public_path__ + "da7ba2dd99bb1e2e37f3f642d7170938.png";